// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthStore$PorterinFeature from "../../../../containers/login/domain/store/AuthStore.mjs";
import * as MobileMenuModuleScss from "../styles/MobileMenu.module.scss";

var styles = MobileMenuModuleScss;

function MobileMenuLogoutSection(Props) {
  var is_authenticated = Props.is_authenticated;
  var onLogout = Props.onLogout;
  return React.createElement(React.Fragment, undefined, is_authenticated ? React.createElement("div", {
                    className: styles.logout,
                    onClick: (function (param) {
                        Curry._1(onLogout, undefined);
                      })
                  }, AuthStore$PorterinFeature.Profile.logout_button) : null);
}

var make = MobileMenuLogoutSection;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
